/**
 * Calculate tax-effective YTW proportionally when order price changes.
 * Returns originalTaxEffectiveYtw * (newYtw / originalYtw), or null if any value is null/undefined/0.
 */
export function calculateProportionalTaxEffectiveYtw(
  originalTaxEffectiveYtw: number | null | undefined,
  originalYtw: number | null | undefined,
  newYtw: number | null | undefined,
): number | null {
  if (originalTaxEffectiveYtw && originalYtw && newYtw) {
    return originalTaxEffectiveYtw * (newYtw / originalYtw)
  }
  return null
}
